import { InjectionToken } from "@angular/core";
import { RUNTIME_APP_CONFIG } from "../app.config";

export const INTERNAL_APP_CONFIG = new InjectionToken<typeof RUNTIME_APP_CONFIG>('INTERNAL_APP_CONFIG');
